import { constants } from "../../../constants";

export default class GameAutoplayStart {
    constructor(gb) {
        Object.assign(this, { gb });
    }

    // Autoplay start is handled in also in GameAutoplayEnd.js
    // ENDOR_handler(data){
    //     this.gb.emitters.emit.web.gameAutoplayStart(data)
    // }

    _default(data) {
        this.gb.emitters.emit.web.gameAutoplayStart(data);
    }

    exposeEvent() {
        let event = {};

        switch (this.gb.gameProviderProtocol) {
            case constants.SPIN:
                event["auto_start"] = this._default;
                break;

            case constants.EDIG:
                event["autoPlayStarted"] = this._default;
                break;
            case constants.T4B:
                event["game.animation.started"] = this._default;
                break;
            case constants.EYE:
                event["autoplayStarted"] = this._default;
                break;
            // case constants.ENDOR:
            //     event["autoplaySwitched"] = this.ENDOR_handler;
            //     break;
            default:
                event["autoplayStart"] = this._default;
        }

        return event;
    }
}
